const MAX_MAILTO_URL_LENGTH = 2000;

export async function openMailTo({
  to,
  subject,
  body,
  onClipboardFallback,
}: {
  to?: string | null;
  subject: string;
  body: string;
  onClipboardFallback: () => void;
}) {
  const fullUrl = `mailto:${to ?? ''}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

  if (fullUrl.length <= MAX_MAILTO_URL_LENGTH) {
    window.open(fullUrl, '_blank');
    return;
  }

  const shortUrl = `mailto:${to ?? ''}?subject=${encodeURIComponent(subject)}`;

  try {
    await navigator.clipboard.writeText(body);
    window.open(shortUrl, '_blank');
    onClipboardFallback();
  } catch {
    // Clipboard can fail (permissions, non-HTTPS) — open with subject only so email client at least opens
    window.open(shortUrl, '_blank');
  }
}
